import {SectorButton} from "../SectorButton";
import {useLangContext} from "shared/features/Language";

import "./AssemblyAreaSelector.scss";

interface IProps {
  activeSector: number;
  setActiveSector: (x: number) => void;
}
export const AssemblyAreaSelector = ({activeSector, setActiveSector}: IProps) => {
  const {textData} = useLangContext();
  return (
    <div className="assembly-area-selector">
      <h5 className="title">{textData.assemblyAreaTitle}</h5>
      <div className="assembly-area-selector__btns">
        {
          Array.from({length: 4}, (_, i) => i)
            .map((x) => (
              <SectorButton key={x} solid={true} sector={x} active={activeSector===x} onClick={() => {setActiveSector(x)}}/>
            ))
        }
      </div>
    </div>
  );
};
